import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    close: 'Back',
    description: {
      first:
        'You will be able to close your wallet once all pending transactions have been validated.',
      second:
        'Your pending transactions should be processed on the next working day.',
    },
    title: 'You have pending transactions on your wallet',
  },
  fr: {
    close: 'Fermer',
    description: {
      first:
        'Vous pourrez procéder à la clôture de votre compte une fois que toutes les transactions en attente auront été validées.',
      second:
        'Vos opérations en cours peuvent être traitées le jour ouvré suivant.',
    },
    title: 'Des opérations sont en cours sur votre compte',
  },
} as const);

export default locales;
